<template>
  <div class="blog-post">
    <a :href="postLink">
      <img :src="image" :alt="post.title" />
      <h3>
        {{ post.title }}
      </h3>
      <small>{{ date }}</small>
      <p v-html="body"></p>
    </a>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "BlogPost",
  props: {
    post: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    postLink() {
      return "/blog/" + this.post.slug;
    },
    image() {
      return this.post.image || "/dashboard-assets/img/album/img-1.jpg";
    },
    date() {
      return moment(this.post.created_at).fromNow();
    },
    body() {
      return this.post.body.slice(0, 150) + "...";
    }
  }
};
</script>
